import { Paths } from 'type-fest';

// Function Overloading
/* eslint-disable no-redeclare */
import { RuntimeConfig } from '../../index';

import { useConfigContextGuard } from './use-config-context-guard.hook';

import { GetFieldType, getValue } from '../get-value.util';

export function useConfig(path?: undefined): { config: RuntimeConfig };
export function useConfig<TPath extends Paths<RuntimeConfig>>(
  path: TPath,
): GetFieldType<RuntimeConfig, TPath>;

export function useConfig(path?: string): any {
  const { config } = useConfigContextGuard();

  // null is a valid config value
  if (path && getValue(config, path) === undefined) {
    throw new Error(`config does not have following path '${path}'`);
  }

  return path ? getValue(config, path) : { config };
}
